var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeEstrela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 104,
    viewBox: "0 0 108 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_246_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0013 15C55.3308 15 56.5448 15.7515 57.1229 16.951L67.037 37.3718L89.1775 40.6379C90.4782 40.8258 91.5621 41.7363 91.9668 42.9936C92.3714 44.2509 92.039 45.6094 91.1141 46.5343L75.0579 62.4605L78.8443 84.9479C79.0611 86.2485 78.5264 87.5637 77.4569 88.3441C76.3875 89.1245 74.9567 89.2112 73.8005 88.5898L54.0013 78.0109L34.2164 88.5753C33.0458 89.1968 31.6295 89.11 30.5601 88.3296C29.4906 87.5492 28.9414 86.2341 29.1582 84.9334L32.9446 62.446L16.8884 46.5343C15.9491 45.6094 15.6311 44.2365 16.0358 42.9936C16.4404 41.7507 17.5243 40.8402 18.825 40.6379L40.9655 37.3718L50.8796 16.951C51.4722 15.7515 52.6717 15 54.0013 15ZM54.0013 26.4171L46.4139 42.0542C45.9081 43.0803 44.9398 43.8029 43.7981 43.9763L26.7014 46.491L39.1157 58.7897C39.9105 59.5845 40.2863 60.7118 40.0984 61.8246L37.1646 79.1237L52.3682 71.0016C53.3943 70.4525 54.6227 70.4525 55.6343 71.0016L70.8379 79.1237L67.9186 61.839C67.7307 60.7262 68.092 59.599 68.9013 58.8041L81.3156 46.5054L64.2188 43.9763C63.0916 43.8029 62.1089 43.0948 61.603 42.0542L54.0013 26.4171Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_246_623",
    x: 0.863525,
    y: 0,
    width: 106.273,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.819608 0 0 0 0 0.858824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_246_623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_246_623",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEstrela);
export default __webpack_public_path__ + "static/media/icone-estrela.400189a855c65cc116e18906cdda823c.svg";
export { ForwardRef as ReactComponent };